module.exports = __webpack_public_path__ + "static/img/ic_delete.9bf5eff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ic_delete.png
// module id = 1028
// module chunks = 1